var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxPlanet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3552 46.1461C11.3578 47.9835 10.7712 50.1888 11.3498 50.8395C11.9632 51.5381 13.7978 51.5888 16.5285 50.7835C14.9605 49.4448 13.5605 47.8955 12.3552 46.1461ZM22.2645 48.3995C26.3872 46.2821 31.4005 42.9515 36.8992 38.0635C42.4058 33.1728 46.3045 28.5888 48.8938 24.7461C48.6138 24.1408 48.3045 23.5488 47.9578 22.9675C44.5605 17.2821 38.5978 13.8875 32.0032 13.8875C28.6512 13.8875 25.3418 14.8101 22.4325 16.5515C18.1472 19.1115 15.1205 23.1701 13.9125 27.9808C12.7045 32.7888 13.4512 37.7968 16.0165 42.0768C17.6005 44.7301 19.7578 46.8581 22.2645 48.3995ZM51.9312 19.3461C53.0538 16.7275 53.2192 14.8981 52.6032 14.2021C51.9925 13.5115 51.2565 13.2528 50.3072 13.3408C49.6885 13.4075 48.7685 13.7061 47.6192 14.4048C49.2512 15.8288 50.7018 17.4768 51.9312 19.3461ZM40.4405 42.0528C36.6832 45.3915 32.6378 48.4021 28.6725 50.8315C29.7498 51.0235 30.8458 51.1568 31.9712 51.1568C35.3232 51.1568 38.6352 50.2341 41.5445 48.4928C45.8298 45.9328 48.8538 41.8768 50.0618 37.0661C50.5338 35.1888 50.6965 33.2795 50.5792 31.3968C47.6992 35.0501 44.2032 38.7115 40.4405 42.0528Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxPlanet);
export default __webpack_public_path__ + "static/media/bx-planet.146373c229498f9d76fc356aa2d0a528.svg";
export { ForwardRef as ReactComponent };